import { Controller } from "@hotwired/stimulus"

// Display-only maths for the payment form; the server re-validates (Payments::Save).
export default class extends Controller {
  static targets = ["amount", "input", "row", "received", "applied", "unapplied"]
  static values = { newUrl: String }

  connect() { this.recalc() }

  changeClient(event) {
    if (!event.target.value) return
    Turbo.visit(`${this.newUrlValue}?client_id=${encodeURIComponent(event.target.value)}`)
  }

  autoAllocate() {
    let left = this.cents(this.amountTarget.value)
    this.rowTargets.forEach((row, i) => {
      const take = Math.min(left, this.cents(row.dataset.balance))
      this.inputTargets[i].value = take > 0 ? (take / 100).toFixed(2) : ""
      left -= take
    })
    this.recalc()
  }

  recalc() {
    const received = this.cents(this.amountTarget.value)
    const applied = this.inputTargets.reduce((sum, input) => sum + this.cents(input.value), 0)
    this.receivedTarget.textContent = this.format(received)
    this.appliedTarget.textContent = this.format(applied)
    this.unappliedTarget.textContent = this.format(received - applied)
    this.unappliedTarget.classList.toggle("text-red-600", applied > received)
  }

  cents(value) { return Math.round((parseFloat(value) || 0) * 100) }
  format(cents) { return "RM " + (cents / 100).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
}
